import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import useSnackBar from "../../../../../../components/Commons/SnackBar/useSnackBar";
import { Menuitem } from "../../../../../../interfaces/Security/menu";
import GenericPromises from "../../../../../../api/GenericPromises";
import { usePermissions } from "../../../../../../hooks/usePermissions";
import { defaultTheme } from "../../../../../../theme/theme";
import { Spinner } from "../../../../../../components/Commons/Spinner/Spinner";
import { Box, Button, Grid } from "@mui/material";
import { DialogEntity } from "../../../../../../components/Dialogs/DialogEntity";
import { Header } from "../../../../../../components/Header";
import { useColors } from "../../../../../../theme/hooks/useColors";
import { CreateButton } from "../../../../../../theme/projects/Buttons/createButton";
import { AddProjectTask } from "./add";
import { TaskItem } from "../components/taskItem";
import { FieldType } from "../../../../../../interfaces/Projects/Catalogs/fieldTypes";
import { useProjectTasksStore } from "../../../../../../store/Projects/ProjectDetails/ProjectTasksStore";
import { ProjectTask } from "../../../../../../interfaces/Projects/Catalogs/projectTasks";

type TableProjectTaskProps = {
  project_stage_id: number | undefined,
  project_id: number | undefined
  isDoneProjectStage: boolean;
  setDialogConfirmChangeStageState: React.Dispatch<React.SetStateAction<boolean>>;
  comboFieldTypes: FieldType[];
}

export const TableProjectTask = ({
  project_stage_id,
  project_id,
  isDoneProjectStage,
  setDialogConfirmChangeStageState,
  comboFieldTypes,
}: TableProjectTaskProps) => {
  const [t] = useTranslation("global");
  const [dataloaded, setDataLoaded] = useState(false);
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const [openDialogAddTask, setOpenDialogAddTask] = useState(false);
  const { GenericGetResource } = GenericPromises();
  const [color, setColor] = useState<number[]>();
  const { HexToRGB } = useColors();
  const { GetResourceByUrl } = usePermissions();
  const setTasksForStage = useProjectTasksStore(store => store.setTasksForStage)
  const getTasksByStageId = useProjectTasksStore(store => store.getTasksByStageId)
  const [tasksForStageLocal, setTasksForStageLocal] = useState<ProjectTask[]>([]);

  const tasksByStage = useProjectTasksStore(store => store.tasksByStage)

  useEffect(() => {
    setDataLoaded(false);
    GenericGetResource(
      `/projecttask/evaluated/byprojectstageid/${project_stage_id}`
    )
      .then(async (response) => {
        if (project_stage_id) {
          setTasksForStage(project_stage_id, response.data.data)
        }
        setColor(HexToRGB(defaultTheme.palette.primary.main));
        GetResourceByUrl(`/projecttask`)
          .then((response1) => {
            setResourceScreen((prev) => response1);
          })
          .catch((error) => {
            showSnackBar(error.message, "error");
          });
      })
      .catch((error) => {
        showSnackBar(error.message, "error");
      })
      .finally(()=>{
    setDataLoaded(true);

      })
  }, []);

  useEffect(() => {
    if (project_stage_id) {
      setTasksForStageLocal(getTasksByStageId(project_stage_id) || []);
    } else {
      setTasksForStageLocal([]);
    }
  }, [tasksByStage]);


  return (
    <>
      {!dataloaded && <Spinner />}
      {dataloaded && resourceScreen?.read && (
        <div className="d-flex mt-4">
          <Grid container spacing={2}
            sx={{
              ...(isDoneProjectStage && { pointerEvents: "none", opacity: 0.5 }),
            }}
          >
            <Grid item xs={12}>
              <CreateButton color={color} onClick={() => { setOpenDialogAddTask(true); }}>
                <AddIcon /> {t("projecttasks.actions.create")}
              </CreateButton>
            </Grid>
            {tasksForStageLocal.map((task) => (
              <TaskItem key={task.project_task_id}
                project_id={project_id}
                resourceScreen={resourceScreen}
                task={task}
                color={color}
                isEdit={!resourceScreen?.update}
                comboFieldTypes={comboFieldTypes}
              />
            ))}
          </Grid>
        </div>
      )}
      <DialogEntity
        content={
          <AddProjectTask
            setOpenDialogAddTask={setOpenDialogAddTask}
            project_id={project_id}
            project_stage_id={project_stage_id}
            comboFieldTypes={comboFieldTypes}
          />
        }
        open={openDialogAddTask}
        setOpen={setOpenDialogAddTask}
        title={
          <Header
            title={t("projecttasks.title-view")}
            size="sm"
          />
        }
      />
      <SnackbarComponent />
    </>
  );
};
